import { render } from "./ActivityPoster.vue?vue&type=template&id=6f2b0754&scoped=true"
import script from "./ActivityPoster.vue?vue&type=script&lang=js"
export * from "./ActivityPoster.vue?vue&type=script&lang=js"

import "./ActivityPoster.vue?vue&type=style&index=0&id=6f2b0754&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2b0754"]])

export default __exports__